module.exports = __webpack_public_path__ + "media/images/500-img-009e87cbf499a2a7d56efc4898060c44.png";